import React from 'react';

const Header = () => {
    return (
        <header>
            <h1>The Dream Keeper!</h1>
            <h2>Your personal online dream journal &#128151; </h2>
            <p>&#129419;I dreamed I was a butterfly, flitting around in the sky; then I awoke. Now I wonder: Am I a man who dreamt of being a butterfly, or am I a butterfly dreaming that I am a man? - Zhuangzi&#129419;</p>
        </header>
    )
}

export default Header;